export default __webpack_public_path__ + "static/media/app-promo-portrait.18306b56.jpeg";